import { Money } from "../common/money";
import { SectionInstance } from "./section-instance";
import { ServiceRequestType } from "./service-request";
import { ServiceRequestHistoryStepData } from "./service-request-history-step-data";

export type ServiceRequestInstance = {
	id: number;
	instanceId?: string;
	createdAt: string;
	customerId: string;
	customerFirstName: string;
	customerLastName: string;
	paymentStatus: number;
	status: number;
	price: Money;
	sectionInstances: SectionInstance[];
	serviceRequest: ServiceRequestType;
	serviceRequestId: string;
	requestTypeId: string;
	updatedAt: string;
	utilityId: string;
	historyStepsData?: ServiceRequestHistoryStepData[];
	transaction?: ServiceRequestInstanceTransaction;
};

export type ServiceRequestInstanceTransaction = {
	id: string;
	reference?: string;
};

export type ServiceRequestPaymentStatus = "Unknown" | "Free" | "Unpaid" | "Paid";
export type ServiceRequestStatus = "Unknown" | "Unassigned" | "Assigned" | "InProgress" | "Completed";

export const ServiceRequestPaymentStatusMap: Record<number, ServiceRequestPaymentStatus> = {
	0: "Unknown",
	1: "Free",
	2: "Unpaid",
	3: "Paid",
};

export const ServiceRequestStatusMap: Record<number, ServiceRequestStatus> = {
	0: "Unknown",
	1: "Unassigned",
	2: "Assigned",
	3: "InProgress",
	4: "Completed",
};

export type ServiceRequestInstanceParams = {
	RequestTypeId: string;
	Page: number;
	PageSize: number;
	PaymentStatus?: string;
	Status?: string;
	CustomerIds?: string[];
	DateFrom?: string;
	DateTo?: string;
};
